import { _ as l, Y as h, g as m, M as u } from "./export-cdcbfb2b.js";
import { a as S } from "./array-iteration-759bfbfa.js";
import { a as T } from "./array-method-is-strict-e5a3c878.js";
var p = S.forEach, v = T, d = v("forEach"), L = d ? [].forEach : function(o) {
  return p(this, o, arguments.length > 1 ? arguments[1] : void 0);
}, y = l, s = L;
y({ target: "Array", proto: !0, forced: [].forEach !== s }, {
  forEach: s
});
var E = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, M = h, t = M("span").classList, i = t && t.constructor && t.constructor.prototype, g = i === Object.prototype ? void 0 : i, n = m, c = E, D = g, a = L, b = u, f = function(r) {
  if (r && r.forEach !== a)
    try {
      b(r, "forEach", a);
    } catch {
      r.forEach = a;
    }
};
for (var e in c)
  c[e] && f(n[e] && n[e].prototype);
f(D);
export {
  g as a,
  E as d
};
